<template>
    <div id="faq" class="ma-6 mb-12" v-if="page && page.faqs && page.faqs.length > 0">
        <div class="faq-header">
            <h2>FAQ</h2>
        </div>

        <v-expansion-panels
                tile
                flat
        >
            <v-expansion-panel
                    v-for="(faq, index) in page.faqs"
                    :key="index"
                    class="px-0"
            >
                <v-expansion-panel-header>
                    <div class="py-4">
                        {{faq.title}}
                    </div>
                    <template v-slot:actions>
                        <v-icon>
                            mdi-chevron-down
                        </v-icon>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div class="pb-6">
                        {{faq.content}}
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
    export default {
        name: 'FaqCollapsible',
        props: ['page']
    }
</script>

<style scoped>
    #faq {
        align: center;
    }
    #faq .v-expansion-panel-header {
        font-size: 20px !important;
        font-weight: 600;
    }
    #faq .v-icon {
        color: #2D76E3 !important;
        font-size: 24pt;
    }
    #faq .faq-header {
        text-align: center;
        padding-bottom: 4px;
    }

    #faq h2 {
        font-size: 30px;
    }

    .v-expansion-panel {
        border-bottom: 1px solid #D8D8D8;
    }

    .v-expansion-panel-header {
        font-weight: 700;
        font-size: 20px;
    }

    .v-expansion-panel-content {
        font-weight: 400;
        font-size: 16px;
    }

</style>
